import React from 'react';
import './App.css';
import FamilyMember from "./FamilyMember";
import {Grid} from "@material-ui/core";
import Background from "./images/background.jpg";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexGrow: 1,
        background: `url(${Background})`,
        minHeight: "100vh",
        alignItems: "center",
        backgroundRepeat:"no-repeat",
        backgroundSize:"cover",
        backgroundPosition:"center"
    },
    grid: {
        padding: theme.spacing(2),
        textAlign: 'center'
    },
}));

function App() {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.grid}>
                <Grid container spacing={6}
                      alignItems="center"
                      justify="center">
                    <Grid item xs={6}>
                        <FamilyMember name = "Kaggen"/>
                    </Grid>
                    <Grid item xs={6}>
                        <FamilyMember name = "Wanja"/>
                    </Grid>
                    <Grid item xs={6}>
                        <FamilyMember name = "Hedda"/>
                    </Grid>
                    <Grid item xs={6}>
                        <FamilyMember name = "Johannes"/>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}

export default App;
